export default {
    'name': 'star',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M12.015 24C11.2469 19.7077 10.5173 17.1692 9.13472 15.4615C7.71378 13.7538 5.60157 12.9231 2.03002 12C5.60157 11.0769 7.71378 10.2 9.13472 8.53846C10.5557 6.83077 11.2469 4.29231 12.015 0C12.7831 4.29231 13.5128 6.83077 14.8953 8.53846C16.3162 10.2462 18.4284 11.0769 22 12C18.4284 12.9231 16.3162 13.8 14.8953 15.4615C13.5128 17.1231 12.8215 19.6615 12.015 24Z\' fill=\'#026958\'/>'
}
